import { render, staticRenderFns } from "./PlantContactPersonData.vue?vue&type=template&id=7590145c&"
import script from "./PlantContactPersonData.vue?vue&type=script&lang=ts&"
export * from "./PlantContactPersonData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports